// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__O8649","Label":"BuildControl_Label__TQkTk","Less":"BuildControl_Less__3Ttg8","More":"BuildControl_More__1MY7B"};